import React, { useState } from 'react';
import PropTypes from 'prop-types';
import InlineError from '../InlineError';
import TextField from "@material-ui/core/TextField";
import './style.css';
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#eee", // As an example color
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none"
    }
    // "& .MuiInputBase-input .MuiOutlinedInput-input":{
    //   backgroundColor:"rbg(123,124,112)",
    // }
    // background:"red",
  },
  button: {
    leftbutton: {
      marginRight: theme.spacing(1),
      backgroundColor: "#3AC2D7",
      color: "#fff",
      width: "150px",
    },
    rightbutton: {
      marginRight: "8px",
      backgroundColor: "#f4f4f4",
      border: "1 solid #000",
      width: "150px",
    },
  },
 
}));
const InputField = (props) => {
  const {
    containerClass, 
    value,
    error,
     onChange, type, label, required, name,
    hasInvalidSubmitOccurred, placeholder,
   

    //  readonly,
    disabled,
     onBlur, getRef = "", className, labelClass, ...rest
  } = props;

  const [touched, setTouched] = useState(false);

  const handleInputBlur = (e, name) => {
    setTouched(true);
    if (onBlur) {
      onBlur(e, name);
    }
    return true;
  };


  const displayError = touched || hasInvalidSubmitOccurred;
  const classes = useStyles();
  return (
   
    <div class="container">
    <div class="material-textfield">
        { label &&
        <label
          htmlFor=""
          // className={labelClass}
        >
          {label}
          {
            required
            && (
              <span className="required">&nbsp;*</span>
            )
          }
        </label>}
        {
          <TextField
          required={required}
            // readOnly={readonly}
            ref={getRef}
            name={name}
            disabled={disabled}
            type={type}
            value={value}
            label={label}
            error={error && error}
            // className={classes.root}
            // className={`input-element ${value ? 'filled' : ''} ${displayError && error ? 'error' : ''} ${className}`}
            onChange={(e) => onChange(e, name)}
            onBlur={(e) => handleInputBlur(e, name)}
            placeholder={placeholder}
            // inputProps={{
            //   style:{backgroundColor:"white"}
            // }}
            // autoComplete="off"
            // InputLabelProps={{
            //   shrink: true,
            // }}
            {...rest}
          />
        }
      </div>
      <div className='error-line'>
      {
        displayError && error && (
          <InlineError message={error} />
        )
      }
      </div>
    </div>
  );

}


InputField.propTypes = {
  value: PropTypes.string,
 

  error: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  onBlur: PropTypes.func,
  hasInvalidSubmitOccurred: PropTypes.bool,

  getRef: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),
  className: PropTypes.string,
  labelClass: PropTypes.string,
  containerClass: PropTypes.string
};

InputField.defaultProps = {
  disabled: false,
  value: '',
  error: '',
  onChange: () => {},
  type: '',
  label: '',
  required: false,
 
  name: '',
  mask: '',
  placeholder: '',
  containerClass: '',
  onBlur: () => { },
  hasInvalidSubmitOccurred: false,
  getRef: () => { },
  className: '',
  labelClass: '',
};

export default InputField;